<template lang="pug">
div
  v-autocomplete.mb-2(label="Go To Item:" v-model="inputIndex" :items="itemsIndex" dense outlined hide-details)
  div.preview-actions.mb-2
    v-btn(v-if="$listeners['open-template-manager']" small @click="$emit('open-template-manager')")
      v-icon(left small) edit
      | Edit Template
    v-btn.ml-2(v-if="component.spreadsheetId" small @click="showRowEditor = true")
      v-icon(left small) mdi-table-edit
      | Edit Item Data
    v-btn.ml-2(v-if="component.spreadsheetId" small @click="openSpreadsheet")
      v-icon(left small) mdi-google-spreadsheet
      | Open Sheet
    v-btn-toggle.ml-2(v-model="viewMode" mandatory dense)
      v-btn(small value="fitted" title="Fit to canvas size")
        v-icon(small) mdi-aspect-ratio
      v-btn(small value="fill" title="Fill panel")
        v-icon(small) mdi-fullscreen
  v-sheet.preview-frame(outlined rounded :style="previewFrameStyle" :class="'mode-' + viewMode")
    template-renderer(v-if="currentItem" :key="currentItemIndex" :game="game" :component="component" :item="currentItem" :compact="viewMode === 'fitted'" :render-priority="-1")
    v-layout(v-else justify-center align-center fill-height)
      span.grey--text Nothing to render.
  v-pagination.mt-1(v-model="currentItemIndex" :length="totalItems" :total-visible="5")
  export-log.mt-1(export-type="item" compact="true")
  spreadsheet-row-editor(v-model="showRowEditor" :component="component" :item-index="currentItemIndex")
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { clamp, range } from 'lodash'
import TemplateRenderer from './TemplateRenderer.vue'
import ExportLog from '../print/ExportLog.vue'
import SpreadsheetRowEditor from './SpreadsheetRowEditor.vue'

const MAX_PREVIEW_HEIGHT = 500

export default {
  props: ["game", "component", "item"],
  components: { ExportLog, TemplateRenderer, SpreadsheetRowEditor },
  created() {
    this._unwatchCache = this.$store.watch(
      (state) => {
        if (!this.component || !this.component.spreadsheetId || !this.component.worksheetId) return null
        return state.cache.cache[`${this.component.spreadsheetId}-${this.component.worksheetId}`]
      },
      () => { this.cacheVersion++ }
    )
  },
  mounted() {
    this.setActiveItem(this.currentItem)
  },
  beforeDestroy() {
    if (this._unwatchCache) this._unwatchCache()
  },
  data() {
    return {
      currentItemIndex: 1,
      showRowEditor: false,
      cacheVersion: 0,
      viewMode: 'fitted',
    }
  },
  computed: {
    ...mapGetters(["getComponentItems", "findComponentTemplate"]),
    previewFrameStyle() {
      if (this.viewMode !== 'fitted') return {}
      const template = this.findComponentTemplate(this.component)
      if (!template || !template.size) return {}
      const { w, h } = template.size
      const maxWidth = Math.round(MAX_PREVIEW_HEIGHT * w / h)
      return {
        'max-width': `${maxWidth}px`,
        'aspect-ratio': `${w} / ${h}`,
        'margin': '0 auto',
      }
    },
    items() {
      void this.cacheVersion
      return this.getComponentItems(this.component)
    },
    totalItems() {
      return this.items.length
    },
    itemsIndex() {
      return range(1, this.totalItems+1)
    },
    currentItem() {
      return this.items[this.currentItemIndex-1]
    },
    inputIndex: {
      get() { return this.currentItemIndex },
      set(newIndex) { this.currentItemIndex = clamp(newIndex, 1, this.totalItems) }
    },
  },
  methods: {
    ...mapActions(["setActiveItem"]),
    openSpreadsheet() {
      const { spreadsheetId, worksheetId } = this.component
      window.open(`https://docs.google.com/spreadsheets/d/${spreadsheetId}/edit#gid=${worksheetId}`, '_blank')
    },
  },
  watch: {
    currentItem(newItem, oldItem) {
      this.setActiveItem(newItem)
    }
  }
}
</script>
<style scoped>
.preview-frame.mode-fill {
  min-height: 400px;
}
</style>
